import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'
import { pauseToolHeartbeat, resumeToolHeartbeat } from '@crossframe/apis/ToolMenu'

export class HeartbeatUtil {

    public static isCurrentlyPaused = false
    private static STOP_AND_FLUSH = 'stopAndFlushToolHeartbeat'
    private static RESTART = 'restartToolHeartbeat'

    public static init = () => {
        console.info('ATBase: Initializing Heartbeat Util')

        document.addEventListener('pause', () => {
            console.info('ATBase: pause event captured, sending message to tool frame for stopping heartbeat')
            HeartbeatUtil.isCurrentlyPaused = true
            HeartbeatUtil.performToolHeartbeatCall(HeartbeatUtil.STOP_AND_FLUSH)
            pauseToolHeartbeat(false)
        })

        document.addEventListener('resume', () => {
            console.info('ATBase: resume event captured, sending message to tool frame for resuming heartbeat')
            HeartbeatUtil.isCurrentlyPaused = false
            HeartbeatUtil.performToolHeartbeatCall(HeartbeatUtil.RESTART)
            resumeToolHeartbeat()
        })
    }

    private static performToolHeartbeatCall = (method) => {
        const meridianToolIframe = document.getElementsByClassName('meridian-tool-frame') as
            HTMLCollectionOf<HTMLIFrameElement>

        if (meridianToolIframe) {
            CrossFrameUtils.sendMessageToOtherFrame({
                frame: meridianToolIframe.item(0).contentWindow,
                message: {
                    method,
                    data: {},
                },
            })
        }
    }
}
